import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { gql } from '@apollo/client'
import { Button, Table } from 'reactstrap'
import Spinner from '../Spinner/Spinner'
import {getTenant} from '../../utils'
import { CROSS_ENTITY_SEARCH_QUERY } from '../../graphql'
import MessageCard from '../MessageCard/MessageCard'
import './Custom.css'
import { getData } from './CustomUtils'

const CROSS_ENTITY_SEARCH = gql(CROSS_ENTITY_SEARCH_QUERY)

export default function CrossEntityReport({ location }) {
  console.log('CrossEntityReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, CROSS_ENTITY_SEARCH, 'crossEntitySearch', setResults, setGraphQLErrors)
  }, [location])

  const landHeadings = ['Case', 'Company', 'Station', 'City', 'Date Research Completed', '']
  const marineHeadings = ['Case', 'Vessel Name', 'Hull Designation', 'Shipyard', 'Date Research Completed', '']
  const contractHeadings = ['Company/Site/Vessel', 'Location', 'Document Type', 'Contract Letter Type', 'Plaintiff', 'Date', 'Overall Contract Number', '']
  const jobsiteHeadings = ['Station, Refinery, Mill, Ect', 'Location', 'Company/Site/Vessel', 'Letter Date', 'Overall Contract Number', 'Plaintiff Name', 'Plaintiff State', 'Plaintiff Name', '']
  const fwInfoStoreHeadings = ['Customer or Vessel', 'Contract Number', 'City', 'State', 'Country', 'Land', '']
  const productionHeadings = ['Title', 'Vessel or Location Name', 'Document Type', '']
  let landResults = []
  let landAKAResults = []
  let landFWResults = []
  let marineResults = []
  let marineAKAResults = []
  let marineFWResults = []
  let OSRTable
  let contractTable
  let contractResults = []
  let jobsiteTable
  let jobsiteResults = []
  let fwInfostoreTable
  let fwInfostoreResults = []
  let productionTable
  let productionResults = []
  let row = []

  function createTable(i, resultsArray) {
    const tenant = getTenant()
    for (let j = 0; j < results[i].sectionData[0].gridData.length; j++) {
      for (let k = 0; k < results[i].sectionData[0].gridData[j].length; k++) {
        if (k === results[i].sectionData[0].gridData[j].length - 1) {
          let href
          if (tenant === 'njasbestos') {
            href = `/custom/search.fwc_view?in_document=${results[i].sectionData[0].gridData[j][k]}`
            row.push(<td key={k}><Link to={href} target="_blank"><Button color="primary" size="sm">View</Button></Link></td>)
          } else {
            href = `/object/${results[i].sectionData[0].gridData[j][k]}?source=${location.pathname}${location.search}`
            row.push(<td key={k}><Link to={href}><Button color="primary" size="sm">View</Button></Link></td>)
          }
        } else {
          row.push(<td key={k}>{results[i].sectionData[0].gridData[j][k]}</td>)
        }
      }
      resultsArray.push(<tr key={j}>{row}</tr>)
      row = []
    }
  }

  function createHeadings(headingsArray) {
    for (let i = 0; i < headingsArray.length; i++) {
      row.push(<th key={i}>{headingsArray[i]}</th>)
    }
    const heading = <tr>{row}</tr>
    row = []
    return (heading)
  }

  if (results) {
    const tenant = getTenant()
    for (let i = 0; i < results.length; i++) {
      if (results[i].sectionName === 'OSR') {
        for (let sectionCounter = 0; sectionCounter < results[i].sectionData.length; sectionCounter++) {
          for (let j = 0; j < results[i].sectionData[sectionCounter].gridData.length; j++) {
            for (let k = 0; k < results[i].sectionData[sectionCounter].gridData[j].length; k++) {
              if (k === results[i].sectionData[sectionCounter].gridData[j].length - 1) {
                let href = `/object/${results[i].sectionData[sectionCounter].gridData[j][k]}?source=${location.pathname}${location.search}`
                if (tenant === 'njasbestos') {
                  href = `/custom/search.fwc_view?in_document=${results[i].sectionData[sectionCounter].gridData[j][k]}`
                  row.push(<td key={k}><Link to={href} target="_blank"><Button color="primary" size="sm">View</Button></Link></td>)
                } else {
                  href = `/object/${results[i].sectionData[sectionCounter].gridData[j][k]}?source=${location.pathname}${location.search}`
                  row.push(<td key={k}><Link to={href}><Button color="primary" size="sm">View</Button></Link></td>)
                }
              } else {
                row.push(<td key={k}>{results[i].sectionData[sectionCounter].gridData[j][k]}</td>)
              }
            }
            switch (sectionCounter) {
              case 0:
                landResults.push(<tr key={j}>{row}</tr>)
                break
              case 1:
                landAKAResults.push(<tr key={j}>{row}</tr>)
                break
              case 2:
                landFWResults.push(<tr key={j}>{row}</tr>)
                break
              case 3:
                marineResults.push(<tr key={j}>{row}</tr>)
                break
              case 4:
                marineAKAResults.push(<tr key={j}>{row}</tr>)
                break
              case 5:
                marineFWResults.push(<tr key={j}>{row}</tr>)
                break
              default:
            }
            row = []
          }
        }

        const landColumnHeadings = createHeadings(landHeadings)
        const marineColumnHeadings = createHeadings(marineHeadings)
        OSRTable =
          <Table bordered className="custom-table" style={{ marginTop: '20px' }}>
            <thead>
              <tr><th colSpan={6} style={{ backgroundColor: 'lightgrey', textAlign: 'left' }}>OSR</th></tr>
              <tr><th colSpan={6} style={{ backgroundColor: 'lightgreen', textAlign: 'left' }}>Land</th></tr>
            </thead>
            <tbody>
              {landColumnHeadings}
              {landResults}
              <tr><th colSpan={6} style={{ backgroundColor: 'lightgreen', textAlign: 'left' }}>Land AKA</th></tr>
              {landColumnHeadings}
              {landAKAResults}
              <tr><th colSpan={6} style={{ backgroundColor: 'lightgreen', textAlign: 'left' }}>Land FW Added</th></tr>
              {landColumnHeadings}
              {landFWResults}
              <tr><th colSpan={6} style={{ backgroundColor: 'lightgreen', textAlign: 'left' }}>Marine</th></tr>
              {marineColumnHeadings}
              {marineResults}
              <tr><th colSpan={6} style={{ backgroundColor: 'lightgreen', textAlign: 'left' }}>Marine AKA</th></tr>
              {marineColumnHeadings}
              {marineAKAResults}
              <tr><th colSpan={6} style={{ backgroundColor: 'lightgreen', textAlign: 'left' }}>Marine FW Added</th></tr>
              {marineColumnHeadings}
              {marineFWResults}
            </tbody>
          </Table>
      }
      if (results[i].sectionName === 'Contract and Production Transmittal Letters') {
        createTable(i, contractResults)
        const contractColumnHeadings = createHeadings(contractHeadings)
        contractTable =
          <Table bordered className="custom-table" style={{ marginTop: '20px' }}>
            <tr><th colSpan={8} style={{ backgroundColor: 'lightgrey', textAlign: 'left' }}>Contract and Production Transmittal Letters</th></tr>
            {contractColumnHeadings}
            {contractResults}
          </Table>
      }
      if (results[i].sectionName === 'Jobsite References') {
        createTable(i, jobsiteResults)
        const jobsiteColumnHeadings = createHeadings(jobsiteHeadings)
        jobsiteTable =
          <Table bordered className="custom-table" style={{ marginTop: '20px' }}>
            <tr><th colSpan={9} style={{ backgroundColor: 'lightgrey', textAlign: 'left' }}>Jobsite References</th></tr>
            {jobsiteColumnHeadings}
            {jobsiteResults}
          </Table>
      }
      if (results[i].sectionName === 'FW Infostore') {
        createTable(i, fwInfostoreResults)
        const fwInfoStoreColumnHeadings = createHeadings(fwInfoStoreHeadings)
        fwInfostoreTable =
          <Table bordered className="custom-table" style={{ marginTop: '20px' }}>
            <tr><th colSpan={7} style={{ backgroundColor: 'lightgrey', textAlign: 'left' }}>FW Infostore</th></tr>
            {fwInfoStoreColumnHeadings}
            {fwInfostoreResults}
          </Table>
      }
      if (results[i].sectionName === 'Production Documents') {
        createTable(i, productionResults)
        const productionColumnHeadings = createHeadings(productionHeadings)
        productionTable =
          <Table bordered className="custom-table" style={{ marginTop: '20px' }}>
            <tr><th colSpan={4} style={{ backgroundColor: 'lightgrey', textAlign: 'left' }}>Production Documents</th></tr>
            {productionColumnHeadings}
            {productionResults}
          </Table>
      }
    }
  }

  if (graphQLErrors.length > 0) {
    return <MessageCard title='Cross Entity Search' message={graphQLErrors[0].message} buttonText='Ok' />
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        {OSRTable}
        {contractTable}
        {jobsiteTable}
        {fwInfostoreTable}
        {productionTable}
      </div>
    )
  }
}
